// SearchForm.js
import { useState } from "react"
import { GoSearch } from "react-icons/go"
import styles from './SearchForm.module.css'
import SearchResList from "./SearchResList"
import { useLanguage } from '../contexts/LanguageContext'
import getData from './Model'

function SearchForm(){
    const { language } = useLanguage()
    const ui = getData('ui', language)
    
    const initialState = ''
    const [searchText, setSearchText] = useState(initialState)
    
    function handleSearchText(event){
        setSearchText(event.target.value)
    }

    return ( 
        <div className={styles.SearchForm}>
            <label><GoSearch />{ui.searchPlaceholder}</label>
            <input 
                data-testid="searchText" 
                placeholder={ui.searchPlaceholder} 
                value={searchText} 
                name="searchText"
                onChange={handleSearchText}
            />
            
            {!!searchText && <SearchResList query={searchText}></SearchResList>}
        </div>
    )
}

export default SearchForm